export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10677.368e0677.jpg";